export default __webpack_public_path__ + "static/media/Dutch_CA_Sample.388f3d4b.png";